import { BehaviorSubject } from 'rxjs';

import { Quote } from '../model/quote';
import { Customer } from '../model/customer';
import { SelectedOption } from '../model/selected-option';
import { OrderInformation } from '../model/order-information';
import { Adjustment } from '../model/adjustment';
import { QuoteRevision } from '../model/quote-revision';

export class QuoteRevisionInfoService {
  quoteId$: BehaviorSubject<any> = new BehaviorSubject(null);
  _quoteRevisions$: BehaviorSubject<QuoteRevision[]> = new BehaviorSubject(null);
  _combinedRevisionUsers$: BehaviorSubject<any[]> = new BehaviorSubject(null);
  _combinedRevisionsData$: BehaviorSubject<any[][]> = new BehaviorSubject(null);
  _quotes$: BehaviorSubject<Quote[]> = new BehaviorSubject(null);
  _customers$: BehaviorSubject<Customer[]> = new BehaviorSubject(null);
  _orders$: BehaviorSubject<OrderInformation[]> = new BehaviorSubject(null);
  _adjustments$: BehaviorSubject<Adjustment[]> = new BehaviorSubject(null);
  _selectedOptions$: BehaviorSubject<SelectedOption[]> = new BehaviorSubject(null);
  _firstRevisionCompare$: BehaviorSubject<number> = new BehaviorSubject(null);
  _secondRevisionCompare$: BehaviorSubject<number> = new BehaviorSubject(null);
  _showQuoteRevisionsAside$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  revertRevisionNumber$: BehaviorSubject<number> = new BehaviorSubject(null);
  _showRevertRevisionAside$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  _isModelProductUpdated$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/quote-revision-info.service.ts